import React from 'react'

const LoadingOverlay = () => {
    var Spinner = require('react-spinkit');
  return (
  <div style={{
    position: "fixed",
    top: '0',
    left:' 0',
    width:' 100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.1)',
    display: 'none',
    justifyContent: 'center',
    alignItems:' center',
    zIndex: '1000',
    }} id='loadingOverlay'>
  <Spinner name="ball-spin-fade-loader" color="#02acf6"/>
  </div>
  )
}

export default LoadingOverlay